import React from "react";

import { BiWorld } from "react-icons/bi";
import { GiTreasureMap } from "react-icons/gi";
import { SuggestionItem } from "../../SuggestionItem";

import {
  ColumnMobile,
  ColumnTitleMobile,
  FixedListMobile,
  ScrollableListMobile,
  SectionRegionalTitleMobile,
  SectionTitleMobile,
  SuggestionListWrapperMobile,
} from "./styles";
import { SuggestionListProps } from "../types";

export const SuggestionListMobile: React.FC<SuggestionListProps> = ({
  title,
  type,
  nationalTitle,
  internationalTitle,
  nationals,
  internationals,
  onSelect,
}) => (
  <SuggestionListWrapperMobile role="list" id="SuggestionListWrapperMobile">
    {title && <SectionTitleMobile>{title}</SectionTitleMobile>}
    <div style={{ display: "flex" }}>
      <ColumnMobile role="list">
        {nationalTitle && (
          <SectionRegionalTitleMobile>
            <GiTreasureMap />
            <ColumnTitleMobile>{nationalTitle}</ColumnTitleMobile>
          </SectionRegionalTitleMobile>
        )}
        <FixedListMobile>
          {(nationals ?? [])
            .filter((suggestion) => suggestion.destak)
            .map((suggestion) => (
              <SuggestionItem
                key={suggestion.code}
                city={suggestion.name}
                code={suggestion.code}
                destak={suggestion.destak}
                onClick={() => onSelect(suggestion)}
              />
            ))}
        </FixedListMobile>
        <ScrollableListMobile>
          {(nationals ?? [])
            .filter((suggestion) => !suggestion.destak)
            .map((suggestion) => (
              <SuggestionItem
                key={suggestion.code}
                city={suggestion.name}
                code={suggestion.code}
                destak={suggestion.destak}
                onClick={() => onSelect(suggestion)}
              />
            ))}
        </ScrollableListMobile>
      </ColumnMobile>
      {type === "destination" && (
        <ColumnMobile role="list">
          {internationalTitle && (
            <SectionRegionalTitleMobile>
              <BiWorld />
              <ColumnTitleMobile>{internationalTitle}</ColumnTitleMobile>
            </SectionRegionalTitleMobile>
          )}
          <FixedListMobile>
            {internationals
              ?.filter((suggestion) => suggestion.destak)
              .map((suggestion) => (
                <SuggestionItem
                  key={suggestion.code}
                  city={suggestion.name}
                  code={suggestion.code}
                  destak={suggestion.destak}
                  onClick={() => onSelect(suggestion)}
                />
              ))}
          </FixedListMobile>
          <ScrollableListMobile>
            {internationals
              ?.filter((suggestion) => !suggestion.destak)
              .map((suggestion) => (
                <SuggestionItem
                  key={suggestion.code}
                  city={suggestion.name}
                  code={suggestion.code}
                  destak={suggestion.destak}
                  onClick={() => onSelect(suggestion)}
                />
              ))}
          </ScrollableListMobile>
        </ColumnMobile>
      )}
    </div>
  </SuggestionListWrapperMobile>
);
